var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20958)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H8C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0Z",
    fill: "url(#paint0_linear_1_20958)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_20958",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12.5H12V36.5H36V12.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_20958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.337 25.4648H27.0192C26.6557 25.4648 26.3594 25.7612 26.3594 26.1246C26.3594 26.3097 26.438 26.4765 26.5607 26.5968L32.4177 32.4538C32.538 32.5834 32.7118 32.6645 32.9017 32.6645C33.1308 32.6645 33.3322 32.5488 33.4503 32.3728C34.8902 30.7013 35.8163 28.5785 35.983 26.2426C35.9923 26.2033 35.9969 26.1639 35.9969 26.1245C35.9969 25.7612 35.7028 25.4648 35.337 25.4648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.509 13.5078C24.1455 13.51 23.8516 13.8041 23.8516 14.1676V23.4115C23.8516 23.7773 24.1455 24.0736 24.509 24.0736H33.7553C34.1188 24.0736 34.4151 23.7773 34.4151 23.4115C34.0886 18.0916 29.8312 13.8343 24.509 13.5078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5919 31.9149L22.7719 25.0948C22.6562 24.9767 22.5868 24.8124 22.5868 24.6342L22.5843 15.0013C22.5843 14.6378 22.2904 14.3438 21.9268 14.3438C16.387 14.6817 12 19.2839 12 24.9073C12 30.7528 16.739 35.4939 22.5843 35.4939C25.2512 35.4939 27.6866 34.5077 29.5479 32.8802C29.6915 32.7597 29.7818 32.5793 29.7818 32.3778C29.7818 32.1995 29.7099 32.0352 29.5919 31.9149Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_20958",
    x1: 10.8692,
    y1: 37.1341,
    x2: 39.1834,
    y2: 8.81995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F42334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FC6058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7866"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.08e8407c5c48c77c8bdf77d676d4f294.svg";
export { ForwardRef as ReactComponent };